export const PRODUCT_KEY = 'products';
export const CLIENT_ID = 'belnick';
export const PRODUCT_UPLOAD_CHUNK_SIZE = 50;
